import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingCRMAdminForm(props) {
  return (
    <SpaceRoleRangeForm
      {...props}
      role="crm_admin"
      settingKey="crm_admin_role_setting"
    />
  );
}

export default SpacesSettingCRMAdminForm;
